import { ReduxAction } from '../../../ReduxStorage/actions';
import { ActionTypes } from './actions';
import { LearnersEmailConsentState, INITIAL_STATE } from './state';

export function LearnersEmailConsent(
  state = INITIAL_STATE,
  action: ReduxAction
): LearnersEmailConsentState {
  switch (action.type) {
    case ActionTypes.FETCH_COURSE_HAS_ENROLMENT_CONSENT_PERMISSION_START:
      return {
        ...state,
        isFetchingHasEnrolmentConsentPermission: true,
      };
    case ActionTypes.FETCH_COURSE_HAS_ENROLMENT_CONSENT_PERMISSION_SUCCESS:
      return {
        ...state,
        isFetchingHasEnrolmentConsentPermission: false,
        hasEnrolmentConsentPermission: action.hasEnrolmentConsentPermission,
      };
    case ActionTypes.UPDATE_LEARNER_HAS_ENROLMENT_CONSENT_PERMISSION_START:
      return {
        ...state,
        isUpdatingHasEnrolmentConsentPermission: true,
      };
    case ActionTypes.UPDATE_LEARNER_HAS_ENROLMENT_CONSENT_PERMISSION_SUCCESS:
      return {
        ...state,
        isUpdatingHasEnrolmentConsentPermission: false,
        hasEnrolmentConsentPermission: true,
      };
    case ActionTypes.UPDATE_LEARNER_HAS_ENROLMENT_CONSENT_PERMISSION_FAILED:
      return {
        ...state,
        isUpdatingHasEnrolmentConsentPermission: false,
        updateHasEnrolmentConsentPermissionError: action.error,
      };
    default: {
      return state;
    }
  }
}
